var _defs, _path, _path2, _circle;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgInstagram = function SvgInstagram(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Calque_1",
    "data-name": "Calque 1",
    viewBox: "0 0 80 80",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-2{fill:#fff0e0}"))), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 20,
    style: {
      fill: "#0c9"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 15.41c8 0 9 0 12.12.17a16.5 16.5 0 0 1 5.57 1 10 10 0 0 1 5.7 5.7 16.5 16.5 0 0 1 1 5.57c.14 3.16.17 4.11.17 12.12s0 9-.17 12.12a16.5 16.5 0 0 1-1 5.57 10 10 0 0 1-5.7 5.7 16.5 16.5 0 0 1-5.57 1c-3.16.14-4.11.17-12.12.17s-9 0-12.12-.17a16.5 16.5 0 0 1-5.57-1 10 10 0 0 1-5.7-5.7 16.5 16.5 0 0 1-1-5.57c-.14-3.16-.17-4.11-.17-12.12s0-9 .17-12.12a16.5 16.5 0 0 1 1-5.57 10 10 0 0 1 5.7-5.7 16.5 16.5 0 0 1 5.57-1c3.16-.14 4.11-.17 12.12-.17M40 10c-8.15 0-9.17 0-12.37.18a22.2 22.2 0 0 0-7.28 1.39 15.46 15.46 0 0 0-8.78 8.78 22.2 22.2 0 0 0-1.39 7.28C10.03 30.83 10 31.85 10 40s0 9.17.18 12.37a22.2 22.2 0 0 0 1.39 7.28 15.46 15.46 0 0 0 8.78 8.78 22.2 22.2 0 0 0 7.28 1.39c3.2.15 4.22.18 12.37.18s9.17 0 12.37-.18a22.2 22.2 0 0 0 7.28-1.39 15.46 15.46 0 0 0 8.78-8.78 22.2 22.2 0 0 0 1.39-7.28c.15-3.2.18-4.22.18-12.37s0-9.17-.18-12.37a22.2 22.2 0 0 0-1.39-7.28 15.46 15.46 0 0 0-8.78-8.78 22.2 22.2 0 0 0-7.28-1.39C49.17 10.03 48.15 10 40 10",
    className: "cls-2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 24.59A15.41 15.41 0 1 0 55.41 40 15.41 15.41 0 0 0 40 24.59M40 50a10 10 0 1 1 10-10 10 10 0 0 1-10 10",
    className: "cls-2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 56.01,
    cy: 23.99,
    r: 3.6,
    className: "cls-2"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgInstagram);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/instagram.ab4a7d502c78c1e5b7aa42bd62d3b820.svg";